module.exports = __webpack_public_path__ + "img/swipe-img-2.7dcfd448.png";